<template lang="pug">
div.row
    draggable(v-model="product.variants", :options="{handle: '.drag-handler'}", @change="onSorting")
        div.col-xs-12.variants(
            v-for="(variant, index) in product.variants",
            :key="index",
            :class="{ 'p-l-lg': hasMultipleVariant }"
        )
            i.fa.fa-bars.drag-handler.text-muted(
                v-show="hasMultipleVariant"
            )

            div.col-xs-1(v-show="hasMultipleVariant")
                label.md-label Default
                div.radio.m-t-md
                    label.md-check
                        input.has-value(
                            type="radio",
                            :value="true",
                            @change="setAsDefault($event, index)",
                            name="default",
                            :checked="variant.default",
                            :disabled="disabled"
                        )
                        i.indigo

            div.col-xs-2
                div.md-form-group
                    input.md-input(
                        type="text"
                        v-model="variant.code",
                        placeholder="X906",
                        :disabled="disabled"
                    )
                    label Code

            div.col-xs-4
                div.md-form-group
                    input.md-input(
                        type="text",
                        v-model="variant.name",
                        required,
                        placeholder="e.g small, medium",
                        :disabled="disabled"
                    )
                    label Name

            div(:class="{ 'col-xs-2': hasMultipleVariant, 'col-xs-3': !hasMultipleVariant }")
                div.md-form-group
                    input.md-input(
                        type="text",
                        v-model="variant.cost",
                        data-parsley-type="number",
                        placeholder="0.00"
                        min="0",
                        :disabled="disabled"
                    )
                    label Cost

            div(:class="{ 'col-xs-2': hasMultipleVariant, 'col-xs-3': !hasMultipleVariant }")
                div.md-form-group
                    input.md-input(
                        type="text",
                        v-model="variant.price",
                        data-parsley-type="number",
                        required,
                        placeholder="0.00"
                        min="0",
                        :disabled="disabled"
                    )
                    label Price

            div.col-xs-1(v-if="hasMultipleVariant && !disabled")
                i.text-muted.material-icons.md-18.btn-del-list.pointer.m-t-md(
                    @click="removeVariant(index)"
                ) &#xe14c;

    div.col-xs-12.text-right.m-t-sm(v-if="!disabled")
        button.btn.btn-outline.btn-sm.rounded.b-success.text-success(
            type="button",
            @click="addVariant()",
        )
            i.material-icons.md-18 &#xe145;
            | Add Variants
</template>

<script>
import draggable from 'vuedraggable';

export default {
    components: {
        draggable,
    },

    props: {
        product: {
            type: Object,
            required: true,
        },

        disabled: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        hasMultipleVariant() {
            return this.product.variants.length > 1;
        },

        hasDefaultVariant() {
            return this.product.variants.filter(v => v.default).length;
        },
    },

    methods: {
        addVariant() {
            let variant = {
                id: null,
                code: null,
                name: '',
                cost: '0.00',
                price: '0.00',
                default: this.hasDefaultVariant ? false : true,
                sequence: this.product.variants.length + 1,
            };

            this.product.variants.push(variant);
        },

        removeVariant(index) {
            let isDefault = this.product.variants[index].default;
            this.product.variants.splice(index, 1);

            if (isDefault) {
                this.autoSetDefaultVariant(index);
            }
        },

        autoSetDefaultVariant(index) {
            let nextIndex = index;

            if (index > 0) {
                nextIndex--;
            }

            this.$set(this.product.variants[nextIndex], 'default', true);
        },

        onSorting(added, removed, moved) {},

        setAsDefault($event, index) {
            // set all as false
            this.product.variants.forEach(v => {
                v.default = false;
            });

            this.$set(this.product.variants[index], 'default', true);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/item/product-variants.vue